// extracted by mini-css-extract-plugin
export default {"page":"rw8ch","mainBanner":"ubsDh","decision":"o_DS6","categories":"vePfd","description":"AVWfQ","benefits":"bdIRA"};